import { isLinkRequired, LINK_REQUIRED_MESSAGE } from '@/utils/member-split/link-required';
import { isPersonalIdInUse, personalIdInUseMessage } from '@/utils/giving-login';

/**
 * The one message a failed `PUT /v2/profile` shows. The store says nothing itself, so
 * each caller shows this: the app's waiting copy for a login its leader has not linked,
 * the server's PERSONAL_ID_IN_USE text (a login with no member chose a personal id that is
 * taken), else the API's own text (a validation array joined), else the caller's fallback.
 */
export function profileSaveErrorMessage(error, fallback) {
  if (isLinkRequired(error)) return LINK_REQUIRED_MESSAGE;
  if (isPersonalIdInUse(error)) return personalIdInUseMessage(error);
  const message = error?.response?.data?.message;
  const text = Array.isArray(message) ? message.join(', ') : message;
  return typeof text === 'string' && text.trim() ? text : fallback;
}
